"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CustomGraphiQL_1 = require("./GraphiQL/CustomGraphiQL");
exports.CustomGraphiQL = CustomGraphiQL_1.CustomGraphiQL;
var fetch = require("isomorphic-fetch");
var graphql_1 = require("graphql");
var TabBar_1 = require("./GraphiQL/TabBar");
var constants_1 = require("./constants");
var cuid = require("cuid");
var Immutable = require("seamless-immutable");
var PlaygroundStorage_1 = require("./PlaygroundStorage");
var getQueryTypes_1 = require("./GraphiQL/util/getQueryTypes");
var debounce_1 = require("graphiql/dist/utility/debounce");
var Observable_1 = require("rxjs/Observable");
var subscriptions_transport_ws_1 = require("subscriptions-transport-ws");
var isQuerySubscription_1 = require("./GraphiQL/util/isQuerySubscription");
var HistoryPopup_1 = require("./HistoryPopup");
var cx = require("classnames");
var SelectUserPopup_1 = require("./SelectUserPopup");
var calculate_size_1 = require("calculate-size");
var CodeGenerationPopup_1 = require("./CodeGenerationPopup/CodeGenerationPopup");
var graphql_2 = require("graphql");
var data_1 = require("./data");
var httpApiPrefix = 'https://api.graph.cool';
var wsApiPrefix = 'wss://dev.subscriptions.graph.cool/v1';
var Playground = function (_super) {
    __extends(Playground, _super);
    function Playground(props) {
        var _this = _super.call(this, props) || this;
        _this.wsConnections = {};
        _this.observers = {};
        _this.graphiqlComponents = [];
        _this.initialIndex = -1;
        _this.updateQueryTypes = debounce_1.default(150, function (sessionId, query) {
            var queryTypes = getQueryTypes_1.default(query);
            _this.setValueInSession(sessionId, 'queryTypes', queryTypes);
        });
        _this.handleQueryChange = debounce_1.default(300, function (sessionId, query) {
            _this.setValueInSession(sessionId, 'query', query);
            _this.updateQueryTypes(sessionId, query);
            if (_this.props.onboardingStep === 'STEP3_UNCOMMENT_DESCRIPTION' && _this.state.selectedSessionIndex === 0) {
                var trimmedQuery = query.replace(/\s/g, '').replace(',', '');
                if (trimmedQuery === data_1.onboardingQuery1Check && typeof _this.props.nextStep === 'function') {
                    _this.props.nextStep();
                }
            }
            if ((_this.props.onboardingStep === 'STEP3_ENTER_MUTATION1_VALUES' || _this.props.onboardingStep === 'STEP3_ENTER_MUTATION2_VALUE') && _this.state.selectedSessionIndex === 1) {
                var trimmedTemplate = data_1.onboardingEmptyMutation.replace(/\s/g, '');
                var trimmedQuery = query.replace(/\s/g, '').replace(',', '');
                if (trimmedQuery !== trimmedTemplate && typeof _this.props.nextStep === 'function') {
                    _this.props.nextStep();
                }
            }
        });
        _this.setWS = function (session) {
            console.log('calling setWS');
            var connectionParams = {};
            if (session.selectedViewer === 'ADMIN' && _this.state.adminAuthToken) {
                connectionParams['Authorization'] = "Bearer " + _this.state.adminAuthToken;
                console.log('setWS: going for admin');
            } else if (session.selectedViewer === 'USER' && session.selectedUserToken) {
                connectionParams['Authorization'] = "Bearer " + session.selectedUserToken;
                console.log('setWS: going for user');
            } else {
                console.log('going for everyone');
            }
            if (_this.wsConnections[session.id]) {
                _this.wsConnections[session.id].unsubscribeAll();
            }
            _this.wsConnections[session.id] = new subscriptions_transport_ws_1.SubscriptionClient(_this.getWSEndpoint(), {
                timeout: 20000,
                connectionParams: connectionParams
            });
        };
        _this.autofillMutation = function () {
            var sessionId = _this.state.sessions[_this.state.selectedSessionIndex].id;
            console.log('trying to autofill mutation', sessionId);
            if (_this.props.onboardingStep === 'STEP3_ENTER_MUTATION1_VALUES') {
                console.log('GOING FOR 1');
                _this.setValueInSession(sessionId, 'query', data_1.onboardingFilledMutation1);
            } else if (_this.props.onboardingStep === 'STEP3_ENTER_MUTATION2_VALUE') {
                console.log('GOING FOR 2');
                _this.setValueInSession(sessionId, 'query', data_1.onboardingFilledMutation2);
            }
            if (typeof _this.props.nextStep === 'function') {
                _this.props.nextStep();
            }
        };
        _this.handleClickCodeGeneration = function (session) {
            _this.setState({
                codeGenerationPopupOpen: true
            });
        };
        _this.handleCloseCodeGeneration = function () {
            _this.setState({ codeGenerationPopupOpen: false });
        };
        _this.handleUserSelection = function (user) {
            var systemApi = _this.getSystemEndpoint();
            var query = "\n      mutation {\n        signinClientUser(input: {\n          projectId: \"" + _this.props.projectId + "\"\n          clientUserId: \"" + user.id + "\"\n          clientMutationId: \"asd\"\n        }) {\n          token\n          clientMutationId\n        }\n      }\n    ";
            fetch(systemApi, {
                method: 'post',
                body: JSON.stringify({ query: query }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + _this.state.adminAuthToken
                }
            }).then(function (res) {
                return res.json();
            }).then(function (res) {
                var token = res.data.signinClientUser.token;
                if (token && _this.state.selectUserSessionId) {
                    _this.setValueInSession(_this.state.selectUserSessionId, 'selectedUserToken', token, function () {
                        var session = _this.state.sessions[_this.state.selectedSessionIndex];
                        _this.resetSubscription(session);
                    });
                }
            });
        };
        _this.handleCreateSession = function (session) {
            var newSession = _this.createSession(session);
            _this.setState(function (state) {
                return __assign({}, state, { sessions: state.sessions.concat(newSession), selectedSessionIndex: state.sessions.length });
            });
        };
        _this.handleItemStarToggled = function (item) {
            _this.setValueInHistory(item.id, 'starred', !item.starred);
        };
        _this.handleCloseSession = function (session) {
            if (_this.state.sessions.length === 1) {
                _this.handleNewSession(true);
            }
            _this.setState(function (state) {
                var i = state.sessions.findIndex(function (s) {
                    return s.id === session.id;
                });
                var nextSelectedSession = state.selectedSessionIndex;
                if (nextSelectedSession > state.sessions.length - 2) {
                    // if it's not the last session
                    if (state.sessions.length > 1) {
                        nextSelectedSession--;
                    }
                }
                return __assign({}, state, { sessions: state.sessions.slice(0, i).concat(state.sessions.slice(i + 1, state.sessions.length)), selectedSessionIndex: nextSelectedSession });
            });
            _this.storage.removeSession(session);
        };
        _this.handleOpenHistory = function () {
            _this.setState({ historyOpen: true });
        };
        _this.handleCloseHistory = function () {
            _this.setState({ historyOpen: false });
        };
        _this.handleSelectSession = function (session) {
            _this.setState(function (state) {
                var i = state.sessions.findIndex(function (s) {
                    return s.id === session.id;
                });
                if (_this.props.onboardingStep === 'STEP3_SELECT_QUERY_TAB' && i === 0 && typeof _this.props.nextStep === 'function') {
                    _this.props.nextStep();
                }
                return __assign({}, state, { selectedSessionIndex: i });
            });
        };
        _this.initSessions = function () {
            if (['STEP3_UNCOMMENT_DESCRIPTION', 'STEP3_OPEN_PLAYGROUND'].indexOf(_this.props.onboardingStep || '') > -1) {
                return _this.initOnboardingSessions();
            }
            // defaulting to admin for deserialized sessions
            var sessions = _this.storage.getSessions(); // .map(session => Immutable.set(session, 'selectedViewer', 'ADMIN'))
            var urlSession = _this.getUrlSession(sessions);
            if (urlSession) {
                if (sessions.length === 1 && sessions[0].query === constants_1.defaultQuery) {
                    return [urlSession];
                }
                return sessions.concat(urlSession);
            }
            if (sessions.length > 0) {
                return sessions;
            }
            return [_this.createSession()];
        };
        _this.saveSessions = function () {
            _this.state.sessions.forEach(function (session) {
                return _this.storage.saveSession(Immutable.set(session, 'subscriptionActive', false), false);
            });
        };
        _this.saveHistory = function () {
            _this.storage.syncHistory(_this.state.history);
        };
        _this.handleNewSession = function (newIndexZero) {
            if (newIndexZero === void 0) {
                newIndexZero = false;
            }
            var session = _this.createSession();
            if (_this.props.onboardingStep === 'STEP3_CREATE_MUTATION_TAB') {
                session = Immutable.set(session, 'query', data_1.onboardingEmptyMutation);
                setTimeout(function () {
                    _this.setCursor({
                        line: 2,
                        ch: 15
                    });
                }, 5);
                if (typeof _this.props.nextStep === 'function') {
                    _this.props.nextStep();
                }
            }
            _this.setState(function (state) {
                return __assign({}, state, { sessions: state.sessions.concat(session), selectedSessionIndex: newIndexZero ? 0 : state.sessions.length });
            });
        };
        _this.createSession = function (session) {
            var newSession;
            if (session) {
                newSession = Immutable.set(session, 'id', cuid());
            } else {
                var query = _this.storage.hasExecutedQuery() ? '' : constants_1.defaultQuery;
                newSession = Immutable({
                    id: cuid(),
                    selectedEndpoint: 'SIMPLE',
                    selectedViewer: 'ADMIN',
                    query: query,
                    variables: '',
                    result: '',
                    operationName: undefined,
                    hasMutation: false,
                    hasSubscription: false,
                    hasQuery: false,
                    queryTypes: getQueryTypes_1.default(query),
                    starred: false
                });
            }
            _this.storage.saveSession(newSession);
            return newSession;
        };
        _this.createSessionFromQuery = function (query) {
            return Immutable({
                id: cuid(),
                selectedEndpoint: 'SIMPLE',
                selectedViewer: 'ADMIN',
                query: query,
                variables: '',
                result: '',
                operationName: undefined,
                hasMutation: false,
                hasSubscription: false,
                hasQuery: false,
                queryTypes: getQueryTypes_1.default(query),
                starred: false
            });
        };
        _this.handleViewerChange = function (sessionId, viewer) {
            _this.setValueInSession(sessionId, 'selectedViewer', viewer, function () {
                if (viewer === 'USER') {
                    // give the user some time to realize whats going on
                    setTimeout(function () {
                        _this.setState({
                            selectUserOpen: true,
                            selectUserSessionId: sessionId
                        });
                    }, 300);
                }
                var session = _this.state.sessions.find(function (session) {
                    return session.id === sessionId;
                });
                if (session) {
                    _this.resetSubscription(session);
                } else {
                    throw new Error('session not found for viewer change');
                }
            });
        };
        _this.handleCloseSelectUser = function () {
            _this.setState({
                selectUserOpen: false
            });
        };
        _this.handleEndpointChange = function (sessionId, endpoint) {
            _this.setValueInSession(sessionId, 'selectedEndpoint', endpoint);
        };
        _this.handleVariableChange = function (sessionId, variables) {
            _this.setValueInSession(sessionId, 'variables', variables);
        };
        _this.handleOperationNameChange = function (sessionId, operationName) {
            _this.setValueInSession(sessionId, 'operationName', operationName);
        };
        _this.cancelSubscription = function (session) {
            _this.setValueInSession(session.id, 'subscriptionActive', false);
            if (session.subscriptionId) {
                _this.wsConnections[session.id].unsubscribe(session.subscriptionId);
                _this.setValueInSession(session.id, 'subscriptionId', null);
            }
        };
        _this.fetcher = function (session) {
            return function (graphQLParams) {
                var query = graphQLParams.query,
                    operationName = graphQLParams.operationName;
                if (!query.includes('IntrospectionQuery')) {
                    if (['STEP3_RUN_QUERY1', 'STEP3_RUN_MUTATION1', 'STEP3_RUN_MUTATION2', 'STEP3_RUN_QUERY2'].indexOf(_this.props.onboardingStep || '') > -1 && typeof _this.props.nextStep === 'function') {
                        if (_this.props.onboardingStep === 'STEP3_RUN_QUERY2') {
                            setTimeout(function () {
                                // typescript wants to be happy...
                                if (typeof _this.props.nextStep === 'function') {
                                    _this.props.nextStep();
                                }
                            }, 2000);
                        } else {
                            _this.props.nextStep();
                        }
                    }
                    if (!_this.historyIncludes(session)) {
                        setImmediate(function () {
                            _this.addToHistory(session);
                        });
                    }
                    if (isQuerySubscription_1.default(query, operationName)) {
                        return Observable_1.Observable.create(function (observer) {
                            _this.observers[session.id] = observer;
                            if (!session.subscriptionActive) {
                                _this.setValueInSession(session.id, 'subscriptionActive', true);
                            }
                            var id = _this.wsConnections[session.id].subscribe(graphQLParams, function (err, res) {
                                var data = { data: res, isSubscription: true };
                                if (err) {
                                    data['error'] = err;
                                }
                                observer.next(data);
                            });
                            _this.setValueInSession(session.id, 'subscriptionId', id);
                            return function () {
                                _this.cancelSubscription(session);
                            };
                        });
                    }
                }
                var endpoint = session.selectedEndpoint === 'SIMPLE' ? _this.getSimpleEndpoint() : _this.getRelayEndpoint();
                var headers = {
                    'Content-Type': 'application/json',
                    'x-graphcool-source': 'console:playground'
                };
                if (session.selectedViewer === 'ADMIN' && _this.state.adminAuthToken) {
                    headers['Authorization'] = "Bearer " + _this.state.adminAuthToken;
                } else if (session.selectedViewer === 'USER' && session.selectedUserToken) {
                    headers['Authorization'] = "Bearer " + session.selectedUserToken;
                }
                return fetch(endpoint, {
                    method: 'post',
                    headers: headers,
                    body: JSON.stringify(graphQLParams)
                }).then(function (response) {
                    if (typeof _this.props.onSuccess === 'function') {
                        _this.props.onSuccess(graphQLParams, response);
                    }
                    if (_this.props.isEndpoint) {
                        history.pushState({}, 'Graphcool Playground', "?query=" + encodeURIComponent(query));
                    }
                    _this.storage.executedQuery();
                    return response.json();
                });
            };
        };
        _this.storage = new PlaygroundStorage_1.default(props.projectId);
        var sessions = _this.initSessions();
        var selectedSessionIndex = parseInt(_this.storage.getItem('selectedSessionIndex'), 10) || 0;
        _this.state = {
            schema: null,
            schemaCache: {
                SIMPLE: null,
                RELAY: null
            },
            userFields: [],
            sessions: sessions,
            selectedSessionIndex: selectedSessionIndex < sessions.length && selectedSessionIndex > -1 ? selectedSessionIndex : 0,
            historyOpen: false,
            history: _this.storage.getHistory(),
            httpApiPrefix: props.httpApiPrefix || httpApiPrefix,
            wsApiPrefix: props.wsApiPrefix || wsApiPrefix,
            adminAuthToken: props.adminAuthToken && props.adminAuthToken.length > 0 && props.adminAuthToken || localStorage.getItem('token'),
            response: undefined,
            selectUserOpen: false,
            selectUserSessionId: undefined,
            codeGenerationPopupOpen: false,
            disableQueryHeader: false
        };
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
            window.addEventListener('beforeunload', function () {
                _this.componentWillUnmount();
            });
        }
        global['p'] = _this;
        return _this;
    }
    Playground.prototype.componentWillMount = function () {
        // look, if there is a session. if not, initiate one.
        this.fetchSchemas().then(this.initSessions);
    };
    Playground.prototype.componentWillUnmount = function () {
        this.storage.setItem('selectedSessionIndex', String(this.state.selectedSessionIndex));
        this.saveSessions();
        this.saveHistory();
        this.storage.saveProject();
    };
    Playground.prototype.componentDidMount = function () {
        if (this.initialIndex > -1) {
            this.setState({
                selectedSessionIndex: this.initialIndex
            });
        }
        if (['STEP3_UNCOMMENT_DESCRIPTION', 'STEP3_OPEN_PLAYGROUND'].indexOf(this.props.onboardingStep || '') > -1) {
            this.setCursor({ line: 3, ch: 6 });
        }
        this.initWebsockets();
    };
    Playground.prototype.initWebsockets = function () {
        var _this = this;
        this.state.sessions.forEach(function (session) {
            return _this.setWS(session);
        });
    };
    Playground.prototype.setCursor = function (position) {
        var editor = this.graphiqlComponents[this.state.selectedSessionIndex].queryEditorComponent.editor;
        editor.setCursor(position);
    };
    Playground.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.projectId !== this.props.projectId || nextProps.adminAuthToken !== this.props.adminAuthToken) {
            this.resetSubscriptions();
            this.fetchSchemas();
        }
    };
    Playground.prototype.fetchSchemas = function () {
        var _this = this;
        return Promise.all([this.props.isEndpoint ? Promise.resolve(null) : this.fetchSchema(this.getRelayEndpoint()), this.fetchSchema(this.getSimpleEndpoint())]).then(function (_a) {
            var relaySchemaData = _a[0],
                simpleSchemaData = _a[1];
            if (!simpleSchemaData || simpleSchemaData.error) {
                _this.setState({
                    response: {
                        date: simpleSchemaData.error,
                        time: new Date()
                    }
                });
                return;
            }
            var relaySchema = relaySchemaData && !relaySchemaData.error && graphql_1.buildClientSchema(relaySchemaData.data);
            var simpleSchema = graphql_1.buildClientSchema(simpleSchemaData.data);
            var userFields = _this.extractUserField(simpleSchema);
            _this.setState({
                schemaCache: {
                    RELAY: relaySchema,
                    SIMPLE: simpleSchema
                },
                userFields: userFields
            });
        });
    };
    Playground.prototype.extractUserField = function (simpleSchema) {
        var userSchema = simpleSchema.getType('User');
        if (userSchema) {
            var userSchemaFields_1 = userSchema.getFields();
            var userFields = Object.keys(userSchemaFields_1).map(function (fieldName) {
                return userSchemaFields_1[fieldName];
            }).filter(function (field) {
                // filter password, meta fields and relation fields
                return field.name[0] !== '_' && field.name !== 'password' && !(field.type instanceof graphql_2.GraphQLList || field.type instanceof graphql_2.GraphQLObjectType);
            });
            // put id to beginning
            userFields.sort(function (a, b) {
                if (a.name === 'id') {
                    return -1;
                }
                if (b.name === 'id') {
                    return 1;
                }
                return a.name > b.name ? 1 : -1;
            });
            return userFields.map(function (field) {
                var size = calculate_size_1.default(field.name, {
                    font: 'Open Sans',
                    fontWeight: '600',
                    fontSize: '16px'
                });
                var width = size.width;
                if (field.name === 'id') {
                    width = 220;
                }
                // TODO create type to field width map
                field.width = Math.max(width, 185) + 50;
                return field;
            });
        } else {
            return [];
        }
    };
    Playground.prototype.fetchSchema = function (endpointUrl) {
        return fetch(endpointUrl, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-graphcool-source': 'console:playground'
            },
            body: JSON.stringify({ query: constants_1.introspectionQuery })
        }).then(function (response) {
            return response.json();
        });
    };
    Playground.prototype.render = function () {
        var _this = this;
        var _a = this.state,
            sessions = _a.sessions,
            selectedSessionIndex = _a.selectedSessionIndex;
        var isEndpoint = this.props.isEndpoint;
        // {
        //   'blur': this.state.historyOpen,
        // },
        if (this.state.selectUserOpen && !this.props.adminAuthToken) {
            throw new Error('The "Select User" Popup is open, but no admin token is provided.');
        }
        var selectedSession = sessions[selectedSessionIndex];
        var selectedEndpointUrl = isEndpoint ? location.href : selectedSession.selectedEndpoint === 'SIMPLE' ? this.getSimpleEndpoint() : this.getRelayEndpoint();
        // const canSelectUsers = this.state.userFields.length > 0
        return React.createElement(
            "div",
            { className: cx('root'), "data-jsx": 3241802770
            },
            React.createElement(_style2.default, {
                styleId: 3241802770,
                css: ".blur[data-jsx=\"3241802770\"] {filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur stdDeviation=\"5\" /></filter></svg>#filter');-webkit-filter: blur(5px);filter: blur(5px);}.graphiqls-container[data-jsx=\"3241802770\"] {height: calc(100vh - 57px);}.h100,\n.root[data-jsx=\"3241802770\"],\n.graphiql-wrapper[data-jsx=\"3241802770\"] {height: 100%;}.flex,\n.root[data-jsx=\"3241802770\"] {display: -ms-flexbox;display: flex;}.flexColumn,\n.root[data-jsx=\"3241802770\"] {-ms-flex-direction: column;flex-direction: column;}.relative,\n.graphiqls-container[data-jsx=\"3241802770\"],\n.graphiql-wrapper[data-jsx=\"3241802770\"] {position: relative;}.overflowHidden,\n.graphiqls-container[data-jsx=\"3241802770\"] {overflow: hidden;}.w100,\n.graphiql-wrapper[data-jsx=\"3241802770\"] {width: 100%;}.h100,\n.root[data-jsx=\"3241802770\"],\n.graphiql-wrapper[data-jsx=\"3241802770\"] {height: 100%;}.relative,\n.graphiqls-container[data-jsx=\"3241802770\"],\n.graphiql-wrapper[data-jsx=\"3241802770\"] {position: relative;}"
            }),
            React.createElement(TabBar_1.TabBar, { sessions: sessions, selectedSessionIndex: selectedSessionIndex, onNewSession: function onNewSession() {
                    return _this.handleNewSession(false);
                }, onCloseSession: this.handleCloseSession, onOpenHistory: this.handleOpenHistory, onSelectSession: this.handleSelectSession, onboardingStep: this.props.onboardingStep, nextStep: this.props.nextStep, tether: this.props.tether }),
            React.createElement(
                "div",
                { className: "graphiqls-container docs-graphiql", "data-jsx": 3241802770
                },
                sessions.map(function (session, index) {
                    return React.createElement(
                        "div",
                        { key: session.id, className: cx('graphiql-wrapper', {
                                'active': index === selectedSessionIndex
                            }), style: {
                                top: "-" + 100 * selectedSessionIndex + "%"
                            }, "data-jsx": 3241802770
                        },
                        React.createElement(CustomGraphiQL_1.CustomGraphiQL, { key: session.id, schema: _this.state.schemaCache[session.selectedEndpoint], fetcher: _this.fetcher(session), selectedEndpoint: session.selectedEndpoint, showQueryTitle: false, showResponseTitle: false, showViewAs: !isEndpoint, showSelectUser: true, showEndpoints: !isEndpoint, showDownloadJsonButton: true, showCodeGeneration: true, selectedViewer: session.selectedViewer, storage: _this.storage.getSessionStorage(session.id), query: session.query, variables: session.variables, operationName: session.operationName, onClickCodeGeneration: function onClickCodeGeneration() {
                                return _this.handleClickCodeGeneration(session);
                            }, onChangeEndpoint: function onChangeEndpoint(endpoint) {
                                return _this.handleEndpointChange(session.id, endpoint);
                            }, onChangeViewer: function onChangeViewer(viewer) {
                                return _this.handleViewerChange(session.id, viewer);
                            }, onEditOperationName: function onEditOperationName(name) {
                                return _this.handleOperationNameChange(session.id, name);
                            }, onEditVariables: function onEditVariables(variables) {
                                return _this.handleVariableChange(session.id, variables);
                            }, onEditQuery: function onEditQuery(query) {
                                return _this.handleQueryChange(session.id, query);
                            }, responses: _this.state.response ? [_this.state.response] : undefined, disableQueryHeader: _this.state.disableQueryHeader, disableResize: true, onboardingStep: index === selectedSessionIndex ? _this.props.onboardingStep : undefined, tether: _this.props.tether, nextStep: _this.props.nextStep, ref: function ref(_ref) {
                                return _this.graphiqlComponents[index] = _ref;
                            }, autofillMutation: _this.autofillMutation, rerenderQuery: _this.props.onboardingStep === 'STEP3_ENTER_MUTATION1_VALUES' || _this.props.onboardingStep === 'STEP3_ENTER_MUTATION2_VALUE', disableAnimation: true })
                    );
                })
            ),
            this.state.historyOpen && React.createElement(HistoryPopup_1.default, { isOpen: this.state.historyOpen, onRequestClose: this.handleCloseHistory, historyItems: this.state.history, onItemStarToggled: this.handleItemStarToggled, fetcherCreater: this.fetcher, schemas: this.state.schemaCache, onCreateSession: this.handleCreateSession }),
            this.props.adminAuthToken && React.createElement(SelectUserPopup_1.default, { isOpen: this.state.selectUserOpen, onRequestClose: this.handleCloseSelectUser, projectId: this.props.projectId, adminAuthToken: this.props.adminAuthToken, userFields: this.state.userFields, onSelectUser: this.handleUserSelection, endpointUrl: this.getSimpleEndpoint() }),
            this.state.codeGenerationPopupOpen && React.createElement(CodeGenerationPopup_1.CodeGenerationPopup, { endpointUrl: selectedEndpointUrl, isOpen: this.state.codeGenerationPopupOpen, onRequestClose: this.handleCloseCodeGeneration, query: selectedSession.query })
        );
    };
    Playground.prototype.resetSubscriptions = function () {
        var _this = this;
        this.state.sessions.forEach(function (session) {
            return _this.resetSubscription(session);
        });
    };
    Playground.prototype.resetSubscription = function (session) {
        if (this.observers[session.id]) {
            this.observers[session.id].complete();
            delete this.observers[session.id];
        }
        this.cancelSubscription(session);
        this.setWS(session);
    };
    Playground.prototype.getUrlSession = function (sessions) {
        var prefix = '?query=';
        if (location.search.includes(prefix)) {
            var uri = location.search.slice(prefix.length, location.search.length);
            var query_1 = decodeURIComponent(uri);
            var equivalent = sessions.findIndex(function (session) {
                return session.query.trim() === query_1.trim();
            });
            if (equivalent > -1) {
                this.initialIndex = equivalent;
            } else {
                return this.createSessionFromQuery(query_1);
            }
        }
        return null;
    };
    Playground.prototype.initOnboardingSessions = function () {
        var session = this.createSession();
        return [__assign({}, session, { query: data_1.onboardingQuery1 })];
    };
    Playground.prototype.setValueInHistory = function (sessionId, key, value) {
        this.setState(function (state) {
            // TODO optimize the lookup with a lookup table
            var i = state.history.findIndex(function (s) {
                return s.id === sessionId;
            });
            return __assign({}, state, { history: Immutable.setIn(state.history, [i, key], value) });
        });
    };
    Playground.prototype.setValueInSession = function (sessionId, key, value, cb) {
        this.setState(function (state) {
            // TODO optimize the lookup with a lookup table
            var i = state.sessions.findIndex(function (s) {
                return s.id === sessionId;
            });
            return __assign({}, state, { sessions: Immutable.setIn(state.sessions, [i, key], value) });
        }, function () {
            if (typeof cb === 'function') {
                cb();
            }
        });
    };
    Playground.prototype.getSimpleEndpoint = function () {
        if (this.props.isEndpoint) {
            return location.pathname;
        }
        return this.state.httpApiPrefix + "/simple/v1/" + this.props.projectId;
    };
    Playground.prototype.getRelayEndpoint = function () {
        return this.state.httpApiPrefix + "/relay/v1/" + this.props.projectId;
    };
    Playground.prototype.getSystemEndpoint = function () {
        return this.state.httpApiPrefix + "/system";
    };
    Playground.prototype.getWSEndpoint = function () {
        return this.state.wsApiPrefix + "/" + this.props.projectId;
    };
    Playground.prototype.addToHistory = function (session) {
        var id = cuid();
        var historySession = Immutable.merge(session, {
            id: id,
            date: new Date()
        });
        this.setState(function (state) {
            return __assign({}, state, { history: [historySession].concat(state.history) });
        });
        this.storage.addToHistory(historySession);
    };
    Playground.prototype.historyIncludes = function (session) {
        var duplicate = this.state.history.find(function (item) {
            return session.query === item.query && session.variables === item.variables && session.operationName === item.operationName && session.selectedViewer === item.selectedViewer && session.selectedEndpoint === item.selectedEndpoint;
        });
        return Boolean(duplicate);
    };
    return Playground;
}(React.Component);
exports.default = Playground;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/Playground.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/Playground.js
// module chunks = 0